import ExcelJS from "exceljs";
import moment from "moment";
import {
  ExportExcelColor,
  ExportPdfColor,
} from "../../../../../root/theme/exportColor";

function isDarkColor(color: string): boolean {
  let r = 0,
    g = 0,
    b = 0;

  if (color.startsWith("rgb")) {
    const match = color.match(/rgb\(\s*(\d+),\s*(\d+),\s*(\d+)\s*\)/);
    if (match) {
      r = parseInt(match[1], 10);
      g = parseInt(match[2], 10);
      b = parseInt(match[3], 10);
    } else return false;
  } else if (color.startsWith("#")) {
    const hex = color.replace("#", "");
    if (hex.length === 6) {
      r = parseInt(hex.substring(0, 2), 16);
      g = parseInt(hex.substring(2, 4), 16);
      b = parseInt(hex.substring(4, 6), 16);
    } else return false;
  } else return false;

  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
  return luminance < 128;
}

const getColor = (value: number, list: any) => {
  const startColor = { r: 222, g: 255, b: 235 }; // #DEFFEB
  const endColor = { r: 2, g: 105, b: 87 }; // #026957
  const index = list.indexOf(value);
  const maxIndex = list.length - 1;
  const ratio = maxIndex === 0 ? 0 : index / maxIndex;
  const r = Math.round(startColor.r + (endColor.r - startColor.r) * ratio);
  const g = Math.round(startColor.g + (endColor.g - startColor.g) * ratio);
  const b = Math.round(startColor.b + (endColor.b - startColor.b) * ratio);

  return value === 0 ? "#444850" : `rgb(${r}, ${g}, ${b})`;
};

export const handleDownloadExcelNew = async (
  columns: string[],
  dummyData: any[],
  filterDetails: string,
) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Weekly Sales Report");

  // Add title
  worksheet.getCell("A1").value = "Weekly Sales Report";
  worksheet.mergeCells("A1:" + String.fromCharCode(65 + 7) + "1");

  const splitFilter = filterDetails.split("*");
  let filterOptions = "";
  if (splitFilter[0].split(",").length === 1) {
    filterOptions =
      "Weekly Sales for " +
      splitFilter[0].split(",")[0] +
      " Generated for the period of " +
      splitFilter[1];
  } else {
    filterOptions =
      "Weekly Sales for " +
      splitFilter[0].split(",").length +
      " Locations Generated for the period of " +
      splitFilter[1];
  }

  worksheet.getCell("B1").value = filterOptions;
  worksheet.getCell("B1").alignment = { horizontal: "left" };
  worksheet.addRow({});

  worksheet.addRow([]);

  // Header row
  const headerRow = worksheet.addRow(columns);
  headerRow.eachCell((cell, colNumber) => {
    if (colNumber === 1)
      cell.alignment = { horizontal: "left", vertical: "middle" };
    else if (colNumber === columns.length)
      cell.alignment = { horizontal: "right", vertical: "middle" };
    else cell.alignment = { horizontal: "center", vertical: "middle" };

    cell.font = { bold: true };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: ExportExcelColor.HeaderRowColorLight },
    };
  });

  // Table rows
  dummyData.forEach((row, rowIndex) => {
    const newRow = worksheet.addRow([
        row.week, // month column
    row.saleCount, 
    row.saleTotal.toFixed(2), 
    row.discount.toFixed(2), 
    row.total.toFixed(2), // Total column
    row.cash.toFixed(2), 
    row.card.toFixed(2), 
    row.otherPayments.toFixed(2), 
    ]);

    newRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      // Alignment
      if (colNumber === 1)
        cell.alignment = { horizontal: "left", vertical: "middle" };
      else if (colNumber === columns.length)
        cell.alignment = { horizontal: "right", vertical: "middle" };
      else cell.alignment = { horizontal: "center", vertical: "middle" };

      // Alternate row colors
      // Footer total row
      if (rowIndex === dummyData.length - 1) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: ExportExcelColor.green }, // light green
        };
        cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      } else {
        // Alternate row colors
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: {
            argb:
              rowIndex % 2 === 0
                ? ExportPdfColor.OddRowColorLight.replace("#", "")
                : ExportPdfColor.EvenRowColorLight.replace("#", ""),
          },
        };
      }
    });
  });

  // Auto column width
  worksheet.columns.forEach((col: any) => {
    let maxLength = 10;
    col.eachCell({ includeEmpty: true }, (cell: any) => {
      maxLength = Math.max(maxLength, cell.value?.toString().length || 10);
    });
    col.width = 25;
  });

  // Row heights
  worksheet.eachRow((row, rowNumber) => {
    row.height = 25;
  });

  // Save file
  const today = moment().format("MMM_Do_YY");
  const fileName = `Weekly_Sales_Report_${today}_${Math.floor(
    100000 + Math.random() * 900000,
  )}.xlsx`;
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
};
